<template>
  <div class="main_div main_div_mobile">

    <div class="module module1">
      <Header :navIndex="0"/>

      <a-row type="flex" justify="center" style="margin-bottom: 20px">
        <a-col :span="6">
          <img :src="vp_transform" height="30"/>
          <div class="vp_txt"> AI智能体 </div>
        </a-col>
        <a-col :span="6">
          <img :src="vp_knowledge" height="30"/>
          <div class="vp_txt"> 知识库 </div>
        </a-col>
        <a-col :span="6">
          <img :src="vp_share" height="30"/>
          <div class="vp_txt"> 一键分享 </div>
        </a-col>
      </a-row>

      <a-row type="flex" align="middle" justify="center">
        <img v-lazy="tx_use_miao_wu" class="img_use_miao_wu"/>
      </a-row>

      <a-row type="flex" justify="start" class="module1_title">
        <a-col :xs="0" :sm="6"/>
        <a-col :xs="24" :sm="18" class="title_build_vp div_left" align="start">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;打造个人AI智能体，用AI技术创造销售新篇章
        </a-col>
      </a-row>
      <a-row align="middle" class="module1_title" style="margin-bottom: 40px" >
        <a-col :xs="0" :sm="6"></a-col>
        <a-col :xs="24" :sm="18" class="title_service div_left" align="start">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;让你对用户的服务随时都在，让你成为品牌AI智能体
        </a-col>
      </a-row>

      <div class="module1_mix" style="position: relative;width: 100%;height: calc(100vh - 300px);">
<!--        绝对定位放置虚拟人图片-->
        <div style="position: absolute;left: calc(-(50vh - 150px));top: 0;width: 100%;">
          <img v-lazy="vp_img"  style="height: calc(100vh - 300px);">
        </div>

      </div>
    </div>

    <!--产品优势-->
    <div class="module module2">
      <div>
        <a-row class="adv_row1" type="flex" align="middle">
          <a-col :xs="8"  align="center">
            <img :src="img_product_advantages_icon" height="116">
          </a-col>
          <a-col :xs="16"  align="start">
            <div class="txt_product_advantage div_left" style="width: 100%; margin-left: 20px">产品优势</div>

          </a-col>
        </a-row>
        <div class="txt_product_advantage_desc div_left" style="width: 100%">
          喵呜AI智能体，您的高效销售方式 <br>只需一张照片，5分钟快速生成您的AI智能体
        </div>
        <a-row class="adv_row2" >
          <a-col :xs="24" :sm="18">
            <div class="product_adv_img" lable="产品优势底板">
              <a-row type="flex" style="width: 100%">
                <a-col :xs="2" :sm="2"/>
                <a-col :xs="6" :sm="3" class="txt_product_adv_time">
                  5min
                </a-col>
                <a-col :xs="16" :sm="7" class="txt_product_adv_time_desc">
                  5分钟快速生成另一个你<br>
                  聊天对话客服解答产品推荐，统统帮你搞定
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-row>
        <a-row class="adv_row2" >
          <a-col :xs="24" :sm="18">
            <div class="product_adv_img" lable="产品优势底板">
              <a-row type="flex" style="width: 100%">
                <a-col :xs="2" :sm="2"/>
                <a-col  :xs="6" :sm="3" class="txt_product_adv_time">
                  24h
                </a-col>
                <a-col  :xs="16" :sm="9" class="txt_product_adv_time_desc">
                  用AI连接世界，人人都可拥有自己的AI智能体<br>
                  AI助手24小时智能对话交流，帮你介绍产品，解答客户疑问
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-row>
      </div>

    </div>

    <!--    核心功能-->
    <div class="module module3" >
      <a-row class="core_fun_row1" type="flex" justify="center">
        <a-col :span="24" class="txt_core_title">核心功能</a-col>
      </a-row>
      <a-row class="core_fun_row2" type="flex" justify="center">
        <a-col :xs="12" :sm="8" class="core_box_col">
          <div>
            <div class="txt_core_icon txt_align_left"><img :src="img_core_1" width="150" height="150" style="margin-left: -25px"></div>
            <div class="txt_core txt_align_left">创建AI智能体</div>
            <div class="txt_core_desc txt_align_left">你可以轻松地创造一个属于你自己的AI智能体！只需自由选择一个你喜欢的模版，上传照片，选择你钟爱的音色，稍等片刻，你就会拥有一个独一无二的AI智能体！</div>
          </div>
        </a-col>

        <a-col :xs="12" :sm="8" class="core_box_col">
          <div>
            <div class="txt_core_icon txt_align_left"><img :src="img_core_2" width="150" height="150" style="margin-left: -25px"></div>
            <div class="txt_core txt_align_left">创建并完善知识库</div>
            <div class="txt_core_desc txt_align_left">仅需录入你的个人信息、组织信息以及详细的产品和服务信息，你就能轻松打造属于你自己的私人知识库，
              在不断细化完善中让AI更深刻地理解你，也让你的客户更快速地了解你！</div>
          </div>
        </a-col>

        <a-col :xs="12" :sm="8" class="core_box_col">
          <div>
            <div class="txt_core_icon txt_align_left"><img :src="img_core_4" width="150" height="150" style="margin-left: -25px"></div>
            <div class="txt_core txt_align_left">知识录入自查工具</div>
            <div class="txt_core_desc txt_align_left">担心您的知识库和产品信息录入不完整，影响AI的销售潜力？试试我们的一键自查工具！它能迅速识别缺失的关键信息并提供精确建议，帮助您优化内容，释放最大销售力。轻松调整，助力销售业绩飞跃，赋能您的商业成功！
            </div>
          </div>
        </a-col>

        <a-col :xs="12" :sm="8" class="core_box_col">
          <div>
            <div class="txt_core_icon txt_align_left"><img :src="img_core_3" width="150" height="150" style="margin-left: -25px"></div>
            <div class="txt_core txt_align_left">测试AI智能体效果</div>
            <div class="txt_core_desc txt_align_left">掌握AI智能体的一切！进入预览中，全面了解你的完整效果，观察其展示能力和对话技能。这里是你的互动实验室，你可以随时测试、调整知识库内容，以确保你与你的客户的互动更加精彩！
            </div>
          </div>
        </a-col>

        <a-col :xs="12" :sm="8" class="core_box_col">
          <div>
            <div class="txt_core_icon txt_align_left"><img :src="img_core_5" width="150" height="150" style="margin-left: -25px"></div>
            <div class="txt_core txt_align_left">分享</div>
            <div class="txt_core_desc txt_align_left">分享是你迅速建立连接的钥匙！通过可编辑的分享内容，以链接或精美图片的形式，让你的客户迅速被你吸引，从而快速开始与它互动。这是让客户快速融入你的世界的方式！
            </div>
          </div>
        </a-col>

        <a-col :xs="12" :sm="8" class="core_box_col">
          <div>
            <div class="txt_core_icon txt_align_left" v-show="false"><img :src="img_core_6" width="150" height="150" style="margin-left: -25px"></div>
            <div class="txt_core txt_align_left"  v-show="false">微信AI机器人（PC端）</div>
            <div class="txt_core_desc txt_align_left"  v-show="false">微信群太多，消息回复来不及？现在，拥有微信AI机器人，让它随时随地为你解忧解难，帮你快速回复消息，
              解决一切问题！不再为繁忙的聊天而烦恼，让AI机器人成为你的智能助手，始终在线为你提供支持和解答。</div>
          </div>
        </a-col>
      </a-row>
    </div>

    <!--    应用场景-->
    <div class="module module4">
      <div style="width: 100%">
        <a-row class="apply_env_row1" type="flex" justify="center">
          <a-col :span="24" class="txt_core_title">应用场景</a-col>
        </a-row>
        <a-row class="apply_env_row2" type="flex" justify="center">

          <a-col :xs="6" :sm="5" style="display: flex;justify-content: center;padding: 0 10px">
            <div class="env_div env_div1">
              <div class="env_bottom" >
                <div class="env_title">
                  在商务社交时
                </div>
                <div class="env_desc">
                  交换AI智能体结识更多有趣的灵魂
                </div>
              </div>
            </div>
            <!--          <img v-lazy="img_env_1" width="256" height="430">-->
          </a-col>

          <a-col :xs="6" :sm="5" style="display: flex;justify-content: center;padding: 100px 10px 0 10px" >
            <div class="env_div env_div2">
              <div class="env_bottom" >
                <div class="env_title">
                  帮你做销售
                </div>
                <div class="env_desc">
                  帮你直播还能招呼粉丝
                </div>
              </div>
            </div>
          </a-col>

          <a-col :xs="6" :sm="5"  style="display: flex;justify-content: center;padding: 0 10px">
            <div class="env_div env_div3">
              <div class="env_bottom" >
                <div class="env_title">
                  你的AI助手
                </div>
                <div class="env_desc">
                  开启你的24小时AI客服
                </div>
              </div>
            </div>
          </a-col>

          <a-col :xs="6" :sm="5" style="display: flex;justify-content: center;padding: 100px 10px 0 10px">
            <div class="env_div env_div4">
              <div class="env_bottom" >
                <div class="env_title">
                  一个能互动的广告
                </div>
                <div class="env_desc">
                  分享你的AI智能体即刻帮你卖产品
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <!--    用户反馈 -->
    <div class="module module5">
      <a-row class="apply_env_row1" type="flex" justify="center" align="middle">
        <a-col :span="24" class="txt_core_title" style="display: flex;align-content: center;justify-content: center">
          <div class="module5_left">
            <div class="txt_core_title" style="text-align: center">用户反馈</div>
          </div>
        </a-col>
      </a-row>

      <a-row class="apply_env_row1" type="flex" justify="space-around" align="middle" style="margin-bottom: 50px">
        <a-col :span="2"></a-col>
        <a-col :span="20" class="txt_core_title" style="display: flex;align-content: center;justify-content: center">
          <div class="module5_left">
            <div class="env_desc">我们致力于持续提升产品体验，因此非常重视您的意见和建议。如果您在使用过程中遇到任何问题或有任何改进建议，
              请随时与我们联系。我们承诺会认真倾听并迅速响应，共同助力产品更好地满足您的需求和期望。<br>我们的邮箱是：service@meupop.com</div>
          </div>
        </a-col>
        <a-col :span="2"></a-col>
      </a-row>

      <a-row class="apply_env_row1" type="flex" justify="space-around" align="middle">
        <a-col :span="2"></a-col>
        <a-col :span="20" class="txt_core_title">
          <img v-lazy="img_feedback_right" class="img_one" width="660" height="404"/>
        </a-col>
        <a-col :span="2"></a-col>
      </a-row>
    </div>

    <!--    底部部分-->
    <div class="module module6" style="position: relative;">
      <div class="div_left" style="background: black;height: 100vh;">
        <img :src="img_build_vp" class="div_left footer_build_vp" style="position: relative;display: flex;text-align: center;justify-content: center">
        <div class="txt_build_vp">快来生成属于你的AI智能体吧</div>
        <div class="txt_go_vp" @click="$router.push('/download')">去生成 →</div>

        <a-row class="footer_row1" type="flex">
          <!-- 商务合作-->
          <a-col flex="1">
            <div class="footer_info">
              <div class="footer_title div_left">
                商务合作
              </div>
              <div class="footer_title_second div_left" @click="jumpCooperate">
                <span><img :src="img_phone" width="16px"/> 联系电话</span>
              </div>
              <div class="footer_title_second div_left" @click="jumpCooperate">
                <span><img :src="img_weixin" width="16px"/> 微信群聊</span>
              </div>
            </div>
          </a-col>
          <a-col flex="1" align="center">
            <div class="footer_info">
              <div class="footer_title div_left">
                关于
              </div>
              <div class="footer_title_second div_left">
                <span @click="footerJump(0)">关于我们</span>
              </div>
            </div>
          </a-col>
          <a-col flex="1">
            <div class="footer_info">
              <div class="footer_title">
                联系我们
              </div>
              <div class="footer_title_second div_left">
                <span @click="footerJump(1)">使用咨询</span>
              </div>
              <div class="footer_title_second div_left">
                <span @click="footerJump(2)">在线客服</span>
              </div>
            </div>
          </a-col>
          <a-col flex="1">
            <div class="footer_info">
              <div class="footer_title">
                支持
              </div>
              <div class="footer_title_second div_left">
                <span>下载</span>
              </div>
            </div>

          </a-col>
        </a-row>
        <!--底部版权声明-->
        <Footer/>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './HeaderMobile.vue'
import Footer from './../Footer.vue'
export default {
  name: 'Main',
  components: {
    Header, Footer
  },
  data () {
    return {
      msg: 'Welcome to Main App',
      vp_img: require('@/assets/modler.png'),
      tx_use_miao_wu: require('@/assets/tx_use_miao_wu.png'),
      vp_share: require('@/assets/vp_share.png'),
      vp_transform: require('@/assets/vp_transform.png'),
      vp_knowledge: require('@/assets/vp_knowledge.png'),
      img_product_advantages_icon: require('@/assets/img_product_advantages_icon.png'),
      img_core_1: require('@/assets/img_core_1.png'),
      img_core_2: require('@/assets/img_core_2.png'),
      img_core_3: require('@/assets/img_core_3.png'),
      img_core_4: require('@/assets/img_core_4.png'),
      img_core_5: require('@/assets/img_core_5.png'),
      img_core_6: require('@/assets/img_core_6.png'),
      // img_env_1: require('@/assets/img_env_1.png'),
      // img_env_2: require('@/assets/img_env_2.png'),
      // img_env_3: require('@/assets/img_env_3.png'),
      // img_env_4: require('@/assets/img_env_4.png'),
      img_build_vp: require('@/assets/img_build_vp.png'),
      img_weixin: require('@/assets/weixin.png'),
      img_phone: require('@/assets/phone.png'),
      img_feedback_right: require('@/assets/img_feedback_right.png')

    }
  },
  created () {
    console.log('Main created', this.$store.state.isMobile)
    if (!this.$store.state.isMobile) {
      this.$router.push('/')
    }
  },
  mounted () {
    // window.addEventListener('wheel', this.handleScroll)
  },
  destroyed () {
    // window.removeEventListener('wheel', this.handleScroll)
  },
  methods: {
    jumpCooperate () {
      this.$router.push({ path: '/help', query: { contact: 2 } })
    },
    footerJump (index) {
      if (index === 0) {
        // 关于我们 点击后跳转到 产品首页
        // 滑动到顶部
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth' // 可选，平滑滚动效果
        })
      } else if (index === 1) {
        // 使用咨询 点击后跳转到 帮助中心 使用指南
        this.$router.push({ path: '/help', query: { contact: 1 } })
      } else {
        // 在线客服 点击后跳转到 帮助中心 常见问题
        this.$router.push({ path: '/help', query: { contact: 0 } })
      }
    },
    handleScroll (event) {
      if (event.deltaY > 0) {
        // 向下滚动
        // 检查当前滚动位置是否小于最后一个 <div> 的位置
        if (window.pageYOffset < (6 - 1) * window.innerHeight) {
          window.scrollTo({
            top: window.pageYOffset + window.innerHeight,
            behavior: 'smooth'
          })
        }
      } else {
        // 向上滚动
        // 检查当前滚动位置是否大于第一个 <div> 的位置
        if (window.pageYOffset > 0) {
          window.scrollTo({
            top: window.pageYOffset - window.innerHeight,
            behavior: 'smooth'
          })
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.img_one{
  width: 100%;
  height: 100%;
}
.title_build_vp{
  height: 60px;
  line-height: 42px;
  font-size: 20px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  display: flex !important;
  align-items: center !important;
}
.title_service{
  height: 22px;
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: rgba(255,255,255,0.8);
  line-height: 18px;
}

.text_left{
  text-align: left;
}

.img_use_miao_wu {
  height: 38px;
}
.vp_txt{
  font-weight: 400;
  color: rgba(255,255,255,0.8);
  line-height: 14px;
  margin-top: 10px;
}

.btn_now{
  width: 166px;
  height: 54px;
  background: #28E04A;
  border-radius: 8px 8px 8px 8px;
  border-color: #28E04A;
  opacity: 1;
  font-size: 18px;
  font-weight: 600;
  color: #000c17;
}
.btn_now_animate{
  display: inline-block;
  animation: headShake;
  animation-duration: 2.2s;
  animate-delay: 2s;
  // animate__repeat-3: 3
  // animate-infinite: infinite
  animation-iteration-count: infinite;
}
.btn_now:hover{
  background: rgb(60, 244, 94);
  color: #000c17;
}

// 产品优势
.module2{
  // padding-top: 20vh;
  padding: 50px 10px 10px 10px
}
.adv_row1{
  width: 100vw;
  height: 140px;

  .txt_product_advantage{
    font-size: 48px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 56px;
    margin-left: 48px;
  }
}
.txt_product_advantage_desc{
  font-size: 16px;
  font-weight: 400;
  color: rgba(255,255,255,0.8);
  line-height: 32px;
  margin: 18px 0 18px 0;

}
.adv_row2{
  width: 100vw;
  height: 172px;
  margin-top: 45px;
  .product_adv_img{
    width: 100%;
    height: 120px;
    background-image: url('./../../assets/img_pruduct_back.png');
    background-size: cover;
    display: flex;
    align-items: center;
  }
  .txt_product_adv_time{
    font-size: 36px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 56px;
    display: flex;
    align-items: center;
    text-align: right;
  }
  .txt_product_adv_time_desc{
    font-size: 14px;
    font-weight: 400;
    color: rgba(255,255,255,0.7);
    line-height: 16px;
    text-align: left;
    display: flex;
    align-items: center;
    padding-right: 15px;
  }
}

// 核心功能
.module3{
  width: 100vw;
  padding-top: 50px;
  .core_fun_row1{
    height: 67px;
    margin-bottom: 42px;
  }
  .txt_core_title{
    font-size: 48px;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 56px;
  }

  // 大于450宽度的大屏/网页端
  @media (min-width: 451px) {
    .core_fun_row2{
      padding: 0 150px 0 150px;
      .core_box_col{
        display: flex;
        justify-content: center;
        .core_box{
          // width: 290px;
        }
      }
    }
  }
  .core_fun_row2{
    text-align: center;
    .txt_core{
      width: 100%;
      font-size: 20px;
      font-weight: 500;
      color: #28E04A;
      line-height: 23px;
      margin: 8px 0 23px 0;
    }

    .txt_core_icon{
      width: 100%;
    }
    .txt_core_desc{
      width: 100%;
      font-size: 13px;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      line-height: 24px;
      margin-bottom: 32px;
      padding: 0 5px;
    }
  }
}

// 应用场景
.module4{
  display: flex;
  align-items: center;
  align-content: center;
  .apply_env_row1{
    height: 67px;
    margin-bottom: 50px;
    .txt_core_title{
      font-size: 48px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 56px;
    }
  }
  .env_div{
    width: 256px;
    height: 430px;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    .env_bottom{
      position: absolute;
      bottom: 0;
      padding: 0 4px 14px 4px;
      text-align: left;
      .env_title{
        font-size: 16px;
        font-weight: 500;
        color: #28E04A;
        line-height: 19px;
        margin-bottom: 10px;
      }
      .env_desc{
        font-size: 14px;
        font-weight: 400;
        color: rgba(255,255,255,0.8);
        line-height: 16px;
      }
    }
  }
  .env_div1{
    background-image: url("./../../assets/img_env_1.png");
  }
  .env_div2{
    background-image: url("./../../assets/img_env_2.png");
  }
  .env_div3{
    background-image: url("./../../assets/img_env_3.png");
  }
  .env_div4{
    background-image: url("./../../assets/img_env_4.png");
  }
}

.module5{
  padding-top: 100px;
  .module5_left{
    width: 302px;
    .txt_core_title{
      width: 100%;
      float: left;
      font-size: 48px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 56px;
      text-align: left;
      margin-bottom: 20px;
    }
    .env_desc{
      width: 100%;
      float: left;
      font-size: 16px;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      line-height: 26px;
      text-align: left;

    }
  }
}
.module6{
  .txt_build_vp{
    width: 100%;
    position: absolute;
    top: 132px; // 50%
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 36px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 42px;
    letter-spacing: 8px;
  }
  .txt_go_vp{
    position: absolute;
    top: 216px; // 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 212px;
    height: 48px;
    right: 25%;
    background: #28E04A;
    border-radius: 6px;
    font-size: 20px;
    font-weight: 500;
    color: #191E2A;
    letter-spacing: 2px;
    text-align: center;
    line-height: 48px;
  }
  .footer_row1{
    float: left;
    width: 100%;
    padding: 0 10px;
    .footer_info{
      margin-top: 50px;
      .footer_title{
        width: 100%;
        font-size: 22px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 22px;
        text-align: center;
        margin-bottom: 30px;
      }
      .footer_title_second{
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        color: rgba(255,255,255,0.9);
        line-height: 23px;
        margin-bottom: 22px;
        text-align: center;
      }
    }

  }
  .footer_build_vp{
    width: 100vw;
    height: 356px;
  }
}

// 大于450宽度的大屏/网页端
@media (min-width: 451px) {
  .title_build_vp{
    line-height: 42px;
    display: flex;
    align-items: center;
  }
}
// 小于450宽度的移动端
@media (max-width: 450px) {
  .img_use_miao_wu {
    height: 28px;
  }
  .text_left{
    padding-left: 20px;
  }
}

.main_div_mobile{
  .module1_title{
    display: flex;
    align-items: center;
    padding: 0 10px;
    margin: 10px 0;
    letter-spacing: 2px;
    .title_build_vp{
      font-size: 18px !important;
      line-height: 32px;
    }
    .title_service{
      font-size: 16px !important;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      line-height: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/MainMobile.vue